
scittle.cljs_bean.init();